import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sofb4: FaireReviewEntity = {
  token: "review_sofb4",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "brand",
  reviewerName: "Therese",
  reviewerLocation: "Windsor, CA",
  stars: 5,
  reviewText: "I couldn’t be happier with my Softies! Comfortable, cozy and great quality. Customers love them too!",
  reviewDate: "Feb 24, 2025",
  purchasedProductTokens: [
    "p_zzwte273ph",
    "p_78fuujjdd3",
  ],
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
